var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSalon = function SvgSalon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M9.1 18.6h-.938a2 2 0 0 1-1.94-1.515L5.054 12.4M9.1 18.6h.326a2 2 0 0 0 1.993-2.166l-.366-4.357M9.1 18.6l.5 2m-4.545-8.2c.493.13 1.01.2 1.545.2 1.538 0 2.927-.222 4.453-.523m-5.998.322A6 6 0 0 1 6.6.6c3.818.001 6.725 1.368 13.07 1.927.522.046.93.48.93 1.005V9.67c0 .524-.408.96-.93 1.005-3.79.334-6.353.956-8.617 1.403M9.6 6.6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  })));
};
export default SvgSalon;